<template>
<div class="ew-page">
  <navbar-dashboard name="Configuración"></navbar-dashboard>

  <div class="ew-page__body">
    <b-alert :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      class="ew-alert">
      Cambios guardados
    </b-alert>

    <section class="ew-card">
      <div class="ew-section">
        <div class="ew-section__header">
          <p class="ew-section__title">Cuenta</p>
          <button type="button" class="ew-link-btn" @click="showModal">Editar</button>
        </div>
        <p class="ew-field-label">Nombre completo</p>
        <p class="ew-field-value">{{name}} {{last_name}}</p>
        <p class="ew-field-label">Correo electrónico</p>
        <p class="ew-field-value">{{email}}</p>
      </div>

      <div class="ew-section">
        <div class="ew-section__header">
          <p class="ew-section__title">Seguridad</p>
          <button type="button" class="ew-link-btn" @click="showModalPassword">Editar</button>
        </div>
        <p class="ew-field-label">Contraseña</p>
        <p class="ew-field-value">••••••••••••</p>
      </div>

      <div class="ew-section">
        <div class="ew-section__header">
          <p class="ew-section__title">Información fiscal</p>
          <button type="button" class="ew-link-btn" @click="showModalEditTaxInformation">Editar</button>
        </div>
      </div>

      <div class="ew-section ew-section--last">
        <p class="ew-section__title">Más detalles de la cuenta</p>
        <label class="ew-checkbox-row">
          <input type="checkbox" class="ew-checkbox" v-model="invoice" :disabled="loading">
          <span>Generar factura automáticamente</span>
        </label>
      </div>
    </section>

    <div class="ew-toolbar ew-toolbar--end">
      <router-link class="ew-btn-outline" to="/dashboard">Cerrar</router-link>
    </div>

    <b-modal ref="editUser" hide-footer title="Edita tu información de cuenta" modal-class="ew-modal">
      <p class="ew-modal__intro">Ayúdanos a personalizar la atención dentro de nuestra plataforma con tu nombre completo. Tu correo electrónico es usado para iniciar sesión.</p>
      <form @submit.prevent="dataAccount" class="ew-form">
        <div class="ew-form__row">
          <div class="ew-form__field">
            <label class="ew-label" for="c-name">Nombres *</label>
            <input id="c-name" type="text" class="ew-input ew-input--block" placeholder="Nombre" v-model="name" required>
          </div>
          <div class="ew-form__field">
            <label class="ew-label" for="c-lastname">Apellidos *</label>
            <input id="c-lastname" type="text" class="ew-input ew-input--block" placeholder="Apellidos" v-model="last_name" required>
          </div>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="c-email">Email *</label>
          <input id="c-email" type="email" class="ew-input ew-input--block" v-model="email" disabled required>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="c-website">Sitio web *</label>
          <input id="c-website" type="text" class="ew-input ew-input--block" placeholder="https://mitienda.com" v-model="website" required>
        </div>
        <div class="ew-modal__actions">
          <button type="button" class="ew-btn-outline" @click="hideModal">Cancelar</button>
          <button class="ew-btn-primary" type="submit">Guardar cambios</button>
        </div>
      </form>
    </b-modal>

    <b-modal ref="editPaswordUser" hide-footer title="Edita tu contraseña" modal-class="ew-modal">
      <p class="ew-modal__intro">Cambiar tu contraseña cada cierto periodo de tiempo ayuda a mantener tu cuenta aún más segura, aquí sólo podrás editar tu contraseña. Si has olvidado tu contraseña <a href="#">haz clic aquí</a> y te ayudaremos a crear una nueva.</p>
      <form @submit.prevent="dataPassword" class="ew-form">
        <div class="ew-form__field">
          <label class="ew-label" for="c-pass-current">Contraseña actual *</label>
          <input id="c-pass-current" type="password" class="ew-input ew-input--block" placeholder="Tu contraseña actual" v-model="password" required>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="c-pass-new">Nueva contraseña *</label>
          <input
            id="c-pass-new"
            type="password"
            class="ew-input ew-input--block"
            placeholder="Mínimo 8 caracteres"
            v-model="new_password"
            required
            @input="$v.new_password.$touch()"
            :class="{ 'is-invalid': $v.new_password.$error }"
          >
          <div class="ew-field-error" v-if="$v.new_password.$error">
            La contraseña debe tener una longitud de entre {{ $v.new_password.$params.minLength.min }} y {{ $v.new_password.$params.maxLength.max }} caracteres
          </div>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="c-pass-rep">Repetir nueva contraseña *</label>
          <input
            id="c-pass-rep"
            type="password"
            class="ew-input ew-input--block"
            placeholder="Repite la nueva contraseña"
            v-model="new_password_rep"
            required
            @input="$v.new_password_rep.$touch()"
            :class="{ 'is-invalid': $v.new_password_rep.$error }"
          >
          <div class="ew-field-error" v-if="$v.new_password_rep.$error">Las contraseñas no coinciden</div>
        </div>
        <div class="ew-modal__actions">
          <button type="button" class="ew-btn-outline" @click="hideModalPassword">Cancelar</button>
          <button class="ew-btn-primary" type="submit">Guardar cambios</button>
        </div>
      </form>
    </b-modal>

    <b-modal ref="editTaxInformation" hide-footer title="Edita tu información fiscal" modal-class="ew-modal">
      <p class="ew-modal__intro">La información fiscal que proporciones aquí será utilizada al momento de generar tus facturas.</p>
      <form @submit.prevent="dataTaxInformation" class="ew-form">
        <div class="ew-form__field">
          <label class="ew-label" for="c-company">Titular *</label>
          <input id="c-company" type="text" class="ew-input ew-input--block" placeholder="Nombre, titular o empresa" v-model="company_name" required>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="c-rfc">RFC *</label>
          <input id="c-rfc" type="text" class="ew-input ew-input--block" placeholder="XXXX000000XXX" v-model="rfc" required>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="c-tax-phone">Teléfono *</label>
          <input id="c-tax-phone" type="text" class="ew-input ew-input--block" placeholder="(442) 123 12 45" v-model="phone" required>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="c-address">Calle y número *</label>
          <input id="c-address" type="text" class="ew-input ew-input--block" placeholder="Av. Felipe Ángeles, 511, Int. J-501" v-model="address" required>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="c-suburb">Colonia *</label>
          <input id="c-suburb" type="text" class="ew-input ew-input--block" placeholder="Los Pedregales" v-model="suburb" required>
        </div>
        <div class="ew-form__row">
          <div class="ew-form__field">
            <label class="ew-label" for="c-cp">Código postal *</label>
            <input id="c-cp" type="text" class="ew-input ew-input--block" placeholder="784596" v-model="postal_code" @keyup="checkAddressDestination" required>
          </div>
          <div class="ew-form__field">
            <label class="ew-label" for="c-state">Estado y ciudad *</label>
            <input id="c-state" type="text" class="ew-input ew-input--block" placeholder="Según C.P." v-model="state_city" required>
          </div>
        </div>
        <div class="ew-modal__actions">
          <button type="button" class="ew-btn-outline" @click="hideModalEditTaxInformation">Cancelar</button>
          <button class="ew-btn-primary" type="submit">Guardar cambios</button>
        </div>
      </form>
    </b-modal>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import commons from '../commons'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Navbar from './Header/Navbar'
import {
  required,
  minLength,
  maxLength,
  email,
  url,
  sameAs
} from 'vuelidate/lib/validators'
export default {
  name: 'Configuration',
  data () {
    return {
      name:'',
      last_name:'',
      email:'',
      website:'',
      password:'',
      new_password:'',
      new_password_rep:'',
      company_name:'',
      rfc:'',
      phone:'',
      address:'',
      suburb:'',
      postal_code:'',
      state_city:'',
      invoice:false,
      loading:false,
      success:true,
      dismissSecs: 5,
      dismissCountDown: 0

    }
  },
  watch: {
    invoice: function (oldValue, newValue) {

      if (newValue === true || newValue === false) {
        this.loading = true
        this.dataInvoice(oldValue)
      }
    }
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    showModal () {
      this.$refs.editUser.show()
    },
    hideModal () {
      this.$refs.editUser.hide()
    },

    showModalPassword(){
      this.$refs.editPaswordUser.show()
    },
    hideModalPassword() {
      this.$refs.editPaswordUser.hide()
    },
    showModalEditTaxInformation(){
      this.$refs.editTaxInformation.show()
    },
    hideModalEditTaxInformation(){
      this.$refs.editTaxInformation.hide()
    },
    updateUser(body, origin){
      axios.put(`${commons.apiURL}/api/v1/users/${localStorage.getItem('ew-user-id')}`, body)
        .then(response => {
          if (origin === "account") {
            this.hideModal()
            this.showAlert()
          } else if(origin === "password"){
            this.hideModalPassword()
            this.showAlert()
          }else if(origin === "taxInformation"){
            this.hideModalEditTaxInformation()
            this.showAlert()
          }else{
            this.loading = false

          }
        })
        .catch(error => {
          console.trace(error)
        })
    },
    dataAccount(){
      let body = {
        website: this.website,
        firstName: this.name,
        lastName : this.last_name
      }
     this.updateUser(body, "account")
    },

    dataPassword(){
      if (this.new_password === this.new_password_rep) {
        var body = {
         password:this.new_password
        }
      }
     this.updateUser(body, "password")
    },
    dataTaxInformation(){
      let body = {
        taxInformation:{
          address:this.address,
          colony:this.suburb,
          postal_code:this.postal_code,
          state_city:this.state_city,
          name:this.company_name,
          rfc:this.rfc,
          phone:this.phone }
      }
      this.updateUser(body, "taxInformation")
    },
    dataInvoice(value){
      let body  = {
        invoice:value
      }
      this.updateUser(body, "invoice")
    },
    checkAddressDestination (event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 4) {
        this.getLocationInfo(query, 'MX').then(response => {
          this.state_city =
           response.data.country_codes[0].state + ', ' + response.data.country_codes[0].city
        })
      }
    },
    getLocationInfo (zipCode, countryCode) {
      return axios.get(
        `${
          commons.apiURL
        }/api/v1/postalcodes?search=${zipCode}&country=${countryCode}`
      )
    },
    ...mapActions(['getUser']),
    ...mapMutations(['setItemActive'])

  },
  computed: {
    ...mapGetters(['user'])
  },
  validations: {
    new_password: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(12)
    },
    new_password_rep: {
      sameAsPassword: sameAs('new_password')
    }
  },
  created () {
    this.setItemActive('configuracion')

    axios.get(`${commons.apiURL}/api/v1/users/${localStorage.getItem('ew-user-id')}`)
        .then(response => {

          this.name = response.data.firstName
          this.last_name = response.data.lastName
          this.email = response.data.email
          this.website = response.data.website
          this.address = response.data.taxInformation.address
          this.suburb = response.data.taxInformation.colony
          this.postal_code = response.data.taxInformation.postal_code
          this.state_city = response.data.taxInformation.state_city
          this.company_name = response.data.taxInformation.name
          this.rfc = response.data.taxInformation.rfc
          this.phone = response.data.taxInformation.phone
          this.invoice = response.data.invoice
        })
        .catch(error => {
          console.trace(error)
        })
  },
  components: {
    'navbar-dashboard': Navbar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-page { @include app-tokens; }
.ew-page__body { padding: 1.75rem 2rem 2.5rem; max-width: 42rem; }

.ew-alert { font-family: var(--app-font); border-radius: var(--app-radius-sm); margin-bottom: 1rem; }

.ew-card { @include ew-card; padding: 0 1.5rem; }

.ew-section {
  padding: 1.5rem 0;
  border-bottom: 1px solid var(--app-border);
  &--last { border-bottom: none; }
}

.ew-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.ew-section__title {
  margin: 0 0 0.75rem;
  font-family: var(--app-font);
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--app-navy);
}
.ew-section__header .ew-section__title { margin-bottom: 0; }

.ew-link-btn {
  border: none;
  background: none;
  padding: 0;
  font-family: var(--app-font);
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--app-accent-button);
  &:hover { text-decoration: underline; }
}

.ew-field-label {
  margin: 0;
  font-family: var(--app-font);
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--app-muted);
}
.ew-field-value {
  margin: 0.15rem 0 0.9rem;
  font-family: var(--app-font);
  font-size: 0.9rem;
  color: var(--app-navy);
}

.ew-checkbox-row {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-family: var(--app-font);
  font-size: 0.85rem;
  color: var(--app-navy-secondary);
  cursor: pointer;
}
.ew-checkbox { @include ew-checkbox; }

.ew-toolbar { margin-top: 1.25rem; &.ew-toolbar--end { display: flex; justify-content: flex-end; } }
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }

.ew-modal__intro {
  margin: 0 0 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--app-border);
  font-family: var(--app-font);
  font-size: 0.85rem;
  line-height: 1.5;
  color: var(--app-muted);
  a { color: var(--app-accent-button); font-weight: 600; }
}
.ew-modal__actions { display: flex; justify-content: flex-end; gap: 0.6rem; }

.ew-form { display: flex; flex-direction: column; gap: 1rem; max-width: none; /* App.vue trae un .ew-form global con max-width:400px legado de los formularios de auth viejos; sin este reset se hereda igual (misma especificidad, propiedades distintas) */ }
.ew-form__row { display: flex; flex-wrap: wrap; gap: 1rem; > .ew-form__field { flex: 1 1 160px; min-width: 0; } }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; &.is-invalid { border-color: #C8102E; } }
.ew-input--block { width: 100%; }
.ew-field-error {
  font-family: var(--app-font);
  font-size: 0.78rem;
  color: #C8102E;
}
</style>

<style lang="scss">
@import "../assets/styles/app-tokens";
.ew-modal {
  .modal-content { border-radius: 0.85rem; border: none; }
  .modal-header { border-bottom: 1px solid $app-border; }
  .modal-title { font-family: $app-font-family; font-weight: 700; color: $app-navy; }
}
</style>



// WEBPACK FOOTER //
// src/components/Configuration.vue